// removed by extract-text-webpack-plugin
module.exports = {"paymentMethodList":"_3hg9K","wrapper":"_15cbL","paymentComponent":"_1s5Cs"};


//////////////////
// WEBPACK FOOTER
// ./components/PaymentMethodList/PaymentMethodList.scss
// module id = 284
// module chunks = 0 1